export default __webpack_public_path__ + "static/media/about-bcg.e58d7a38.jpg";